import { VideoProject } from "@/services/bedrock";

import { getKanbanColumnId, KANBAN_COLUMNS, KanbanColumnId } from "./kanbanColumns";

interface KanbanDropOptions {
  requiresQa?: boolean | null;
  currentUserId?: number;
}

export function getValidKanbanDropColumnIds(
  fromStatus: VideoProject.Status,
  options?: KanbanDropOptions
): KanbanColumnId[] {
  return KANBAN_COLUMNS.map(column => column.id).filter(
    columnId => getVideoProjectEventForKanbanDrop(fromStatus, columnId, options) !== null
  );
}

export interface KanbanDropEventRequest {
  event: VideoProject.Event;
  userId?: number;
}

export function getVideoProjectEventForKanbanDrop(
  fromStatus: VideoProject.Status,
  toColumnId: KanbanColumnId,
  options?: KanbanDropOptions
): KanbanDropEventRequest | null {
  const fromColumn = getKanbanColumnId(fromStatus);
  if (!fromColumn || fromColumn === toColumnId) {
    return null;
  }

  switch (toColumnId) {
    case "editing":
      if (fromStatus === VideoProject.Status.SUBMITTED_FOR_EDITING) {
        return { event: VideoProject.Event.START_EDITING, userId: options?.currentUserId };
      }
      if (fromStatus === VideoProject.Status.SUBMITTED_FOR_TESTING) {
        return { event: VideoProject.Event.RETURN_TO_EDITING };
      }
      if (fromStatus === VideoProject.Status.TESTING) {
        return { event: VideoProject.Event.REJECT_QA };
      }
      if (fromStatus === VideoProject.Status.READY_TO_POST || fromStatus === VideoProject.Status.SCHEDULED) {
        return { event: VideoProject.Event.REQUEST_REVISION };
      }
      return null;

    case "submitted_for_editing":
      if (fromStatus === VideoProject.Status.EDITING) {
        return { event: VideoProject.Event.STOP_EDITING };
      }
      return null;

    case "submitted_for_testing":
      if (fromStatus === VideoProject.Status.EDITING) {
        return { event: VideoProject.Event.SUBMIT_FOR_TESTING };
      }
      if (fromStatus === VideoProject.Status.TESTING) {
        return { event: VideoProject.Event.STOP_TESTING };
      }
      return null;

    case "testing":
      if (fromStatus === VideoProject.Status.SUBMITTED_FOR_TESTING) {
        return { event: VideoProject.Event.START_TESTING, userId: options?.currentUserId };
      }
      return null;

    case "completed":
      if (fromStatus === VideoProject.Status.EDITING) {
        return options?.requiresQa ? null : { event: VideoProject.Event.COMPLETE };
      }
      if (fromStatus === VideoProject.Status.TESTING) {
        return { event: VideoProject.Event.APPROVE_QA };
      }
      return null;

    default:
      return null;
  }
}
